"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologicalPointCollectionCache = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var store_1 = require("../../store");
var Cacheable = /** @class */ (function () {
    function Cacheable() {
        this.cache = {};
    }
    Cacheable.prototype.push = function (key, value, ttlMs) {
        this.cache[key] = value;
    };
    Cacheable.prototype.flush = function () {
        this.cache = {};
    };
    Cacheable.prototype.drop = function (key) {
        this.cache = (0, lodash_1.omit)(this.cache, key);
    };
    Cacheable.prototype.read = function (key) {
        return this.cache[key] || null;
    };
    Cacheable.prototype.view = function (transformer) {
        var _this = this;
        return function (key) {
            var existing = _this.read(key);
            if (existing) {
                return existing;
            }
            var result = transformer(key);
            if (result) {
                _this.push(key, result);
            }
            return _this.read(key);
        };
    };
    Cacheable.prototype.all = function () {
        return Object.freeze(tslib_1.__assign({}, this.cache));
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], Cacheable.prototype, "cache", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], Cacheable.prototype, "push", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Cacheable.prototype, "flush", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Cacheable.prototype, "drop", null);
    return Cacheable;
}());
var TopologicalPointCollectionCache = /** @class */ (function () {
    function TopologicalPointCollectionCache() {
    }
    TopologicalPointCollectionCache.dropCollectionVectors = function (revision) {
        TopologicalPointCollectionCache.vectors.drop(revision);
    };
    TopologicalPointCollectionCache.dropCollectionLocations = function (revision) {
        TopologicalPointCollectionCache.dropCollectionVectors(revision);
        TopologicalPointCollectionCache.locations.drop(revision);
        TopologicalPointCollectionCache.dropCollectionPoleAccuracy(revision);
    };
    TopologicalPointCollectionCache.dropCollectionPoleAccuracy = function (revision) {
        TopologicalPointCollectionCache.poleAccuracy.drop(revision);
    };
    TopologicalPointCollectionCache.addVector = function (sourceRevision, field) {
        var source = TopologicalPointCollectionCache.getCollectionLocation(sourceRevision);
        var _a = field.value, bearing = _a.bearing, distance = _a.distance;
        var target = core_shared_1.IkeGeodesic.projectLocation(source, bearing, distance);
        var vectors = TopologicalPointCollectionCache.getCollectionVectors(sourceRevision);
        vectors.push({ field: field, source: source, target: target });
        TopologicalPointCollectionCache.vectors.push(sourceRevision, vectors);
    };
    TopologicalPointCollectionCache.flushVectors = function () {
        this.vectors.flush();
    };
    TopologicalPointCollectionCache.vectors = new Cacheable();
    TopologicalPointCollectionCache.locations = new Cacheable();
    TopologicalPointCollectionCache.poleAccuracy = new Cacheable();
    TopologicalPointCollectionCache.getCollectionVectors = TopologicalPointCollectionCache.vectors.view(function (revision) {
        var collection = store_1.AppStore.Collection.get(revision);
        var source = TopologicalPointCollectionCache.getCollectionLocation(revision);
        if (!source || !collection) {
            return [];
        }
        var output = [];
        collection.forEachField(function (field) {
            if (!field.value) {
                return;
            }
            if (core_shared_1.CollectionModelFieldVector.isVectorField(field)) {
                var value = field.value;
                var target = core_shared_1.IkeGeodesic.projectLocation(source, value.bearing, value.distance);
                output.push({ field: field, source: source, target: target });
            }
            if (core_shared_1.CollectionModelFieldAnchor.isAnchorField(field)) {
                var _a = field.distanceBearingPitch(source), distance = _a.distance, bearing = _a.bearing;
                if (distance === 0) {
                    return;
                }
                var target = core_shared_1.IkeGeodesic.projectLocation(source, bearing, distance);
                if (target && target.latitude && target.longitude) {
                    output.push({ field: field, source: source, target: target });
                }
            }
        });
        return output;
    });
    TopologicalPointCollectionCache.getCollectionLocation = TopologicalPointCollectionCache.locations.view(function (revision) {
        var collection = store_1.AppStore.Collection.get(revision);
        if (collection == null) {
            return null;
        }
        return collection.location;
    });
    TopologicalPointCollectionCache.getCollectionPoleAccuracy = TopologicalPointCollectionCache.poleAccuracy.view(function (revision) {
        var collection = store_1.AppStore.Collection.get(revision);
        var field = collection.locationModelField;
        var poleAccuracy = 'default';
        if (core_shared_1.CollectionModelFieldLocation.isLocationField(field)) {
            switch (field.provider) {
                case 'truesize':
                    poleAccuracy = 'low';
                    break;
                case 'gps':
                    var accuracy = field.value.accuracy;
                    if (field.raw.fix === 'rtkfixed') {
                        poleAccuracy = accuracy > 0.1 ? 'rtk_float' : 'rtk_fixed';
                    }
                    else if (field.raw.fix === 'rtkfloat') {
                        poleAccuracy = accuracy > 1 ? 'low' : 'rtk_float';
                    }
                    else {
                        poleAccuracy = 'low';
                    }
                    break;
                default:
                    poleAccuracy = field.provider;
            }
        }
        else {
            poleAccuracy = 'low';
        }
        return poleAccuracy;
    });
    return TopologicalPointCollectionCache;
}());
exports.TopologicalPointCollectionCache = TopologicalPointCollectionCache;
//# sourceMappingURL=point.collection.cache.js.map